import PropTypes from 'prop-types';
import React from 'react';
import OptionalCheckboxGroup from 'core/modules/components/lists/components/OptionalCheckboxGroup/OptionalCheckboxGroup';
import GoogleClassroomStudentItem from '../GoogleClassroomStudentItem/GoogleClassroomStudentItem';

const GoogleClassroomStudentsList = ({ classGuid, students, onChangeSelected, legend, isLegendHidden }) => {
  const content = students.map((student) => {
    return (
      <GoogleClassroomStudentItem
        key={student.guid}
        selected={student.selected}
        guid={student.guid}
        classGuid={classGuid}
        avatar={student.avatar}
        name={student.name}
        lastname={student.lastname}
        email={student.email}
        onChangeSelected={onChangeSelected}
      />
    );
  });

  return (
    <OptionalCheckboxGroup className="google-clasroom-students-list" isLegendHidden={isLegendHidden} legend={legend}>
      {content}
    </OptionalCheckboxGroup>
  );
};

GoogleClassroomStudentsList.propTypes = {
  classGuid: PropTypes.string,
  isLegendHidden: PropTypes.bool,
  legend: PropTypes.string,
  onChangeSelected: PropTypes.func,
  students: PropTypes.array,
};

GoogleClassroomStudentsList.defaultProps = {
  students: [],
};

export default GoogleClassroomStudentsList;
